import * as _ from "lodash";
import { createSelector } from "reselect";
import { EntryType } from "user/user/User";
//-- Selector -------------------------------------------------------------------------------------------------------------------------------
const mapLeadItems = (items) => {
    let temp = [];
    if (items) {
        temp = items;
    }
    return temp;
};
const stateReportSelector = (state) => state.reports.agencyReports.overviewReport;
const userAccessSelector = (state) => state.user.userAccess;
const adjustReport = (officeIds, report) => {
    for (var i = 0; i < report.items.length; i++) {
        let item = report.items[i];
        if (!officeIds.find((id) => id == item.officeId)) {
            item.officeId = null;
        }
    }
};
const getAllOfficeIds = (userAccess) => {
    let officeIds = [];
    userAccess.forEach((item) => {
        if (item.type == EntryType.Office) {
            officeIds.push(item.id);
        }
    });
    return officeIds;
};
export const reportSelector = createSelector(stateReportSelector, userAccessSelector, (report, userAccess) => {
    if (!report) {
        return {
            isFetching: true,
            reportData: null
        };
    }
    let reportClone = _.cloneDeep(report);
    // Hide ids of offices we dont have access to
    // This will make it not possible to link to the Office reports
    if (report.items) {
        let officeIds = getAllOfficeIds(userAccess);
        adjustReport(officeIds, reportClone);
    }
    return {
        isFetching: reportClone.isFetching,
        reportData: {
            agencyId: reportClone.agencyId,
            agencyName: reportClone.agencyName,
            startDate: reportClone.startDate,
            endDate: reportClone.endDate,
            items: mapLeadItems(reportClone.items),
            totals: reportClone.totals
        }
    };
});
export default reportSelector;
